var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1563",
    xmlSpace: "preserve",
    width: 300,
    height: 300,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1567"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1577"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path1575",
    fill: "#0047ba",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1569",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1573",
    clipPath: "url(#clipPath1577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1579",
    transform: "translate(358.1035,203.8457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -14.357,0 -26.295,10.329 -28.809,23.959 h -3.67 c -3.635,0 -6.579,2.988 -6.579,6.579 v 19.947 h -2.055 c -3.618,0 -6.578,2.96 -6.578,6.578 0,23.701 -10e-4,23.812 -10e-4,27.745 0,3.643 3.005,6.578 6.579,6.578 h 5.831 v 8.435 c 0,7.406 -3.703,14.303 -9.836,18.456 -3.661,2.48 -7.102,5.259 -10.3,8.292 -67.099,41.081 -155.982,32.592 -214.064,-25.49 -68.039,-68.04 -68.04,-178.354 0,-246.394 68.04,-68.041 178.355,-68.04 246.394,0 43,42.999 58.778,102.873 47.428,158.299 C 19.079,5.154 10.143,0 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1581",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1583",
    transform: "translate(310.4111,288.6533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,3.643 3.006,6.578 6.579,6.578 h 5.831 v 8.435 c 0,7.406 -3.703,14.303 -9.836,18.456 -3.662,2.481 -7.102,5.26 -10.301,8.294 C -77.049,84.2 -169.775,73.765 -227.587,10.183 -167.615,-55.764 -70.042,-64.568 0.001,-16.379 0.001,-8.939 0,-11.346 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1585",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1587",
    transform: "translate(82.8242,64.6181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 69.187,76.08 188.664,76.232 257.989,0 188.744,-76.156 69.242,-76.152 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1589",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1591",
    transform: "translate(273.2343,304.9243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -33.919,68.04 -88.912,68.04 -122.831,0 -33.919,-68.04 -33.919,-178.354 0,-246.395 33.919,-68.04 88.912,-68.039 122.831,0 C 33.919,-178.354 33.919,-68.04 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1593",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1595",
    transform: "translate(88.6211,58.5298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 68.04,-68.04 178.355,-68.04 246.395,0 34.02,34.021 51.03,78.609 51.03,123.198 H -51.029 C -51.029,78.609 -34.02,34.021 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1597",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1599",
    transform: "translate(358.1035,203.8457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -14.357,0 -26.295,10.329 -28.809,23.959 h -3.67 c -0.003,0 -0.005,0 -0.007,0 -3.663,0.006 -6.572,3.043 -6.572,6.579 v 19.947 h -2.055 c -3.618,0 -6.578,2.96 -6.578,6.578 0,10.86 -10e-4,12.141 -10e-4,18.425 0,-0.001 10e-4,-0.002 10e-4,-0.002 v 2.285 c 0,0 -10e-4,-0.002 -10e-4,-0.003 v 7.04 c 0,0.008 0.002,0.016 0.002,0.024 0.008,2.104 1.046,4.099 2.777,5.33 0,0 10e-4,10e-4 10e-4,10e-4 h 10e-4 c 1.133,0.809 2.487,1.223 3.798,1.223 h 5.831 v 8.435 c 0,7.406 -3.703,14.303 -9.836,18.456 -3.661,2.48 -7.102,5.259 -10.3,8.292 -27.797,17.019 -59.329,25.54 -90.866,25.54 v -348.454 c 44.589,0 89.177,17.01 123.196,51.029 43,42.999 58.778,102.874 47.428,158.3 C 19.079,5.154 10.143,0 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1601",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1603",
    transform: "translate(397.1611,234.3833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 13.369 c 0,3.618 -2.96,6.578 -6.578,6.578 h -64.959 c -3.618,0 -6.578,-2.96 -6.578,-6.578 V 0 c 0,-3.618 2.96,-6.578 6.578,-6.578 H -6.578 C -2.96,-6.578 0,-3.618 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1605",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1607",
    transform: "translate(358.1035,295.2314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 52.379",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1609",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1611",
    transform: "translate(373.7402,374.7368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -31.273 c -5.315,0 -9.663,-4.348 -9.663,-9.662 v -7.803 c 0,-5.314 4.348,-9.661 9.663,-9.661 H 0 c 5.313,0 9.661,4.347 9.661,9.661 v 7.803 C 9.661,-4.348 5.313,0 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1613",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1615",
    transform: "translate(462.4228,388.8647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 11.985",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1617",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1619",
    transform: "translate(241.7978,388.8647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 11.985",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1621",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1623",
    transform: "translate(431.8681,462.6303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 8.476,8.475",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1625",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1627",
    transform: "translate(284.3379,462.6303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -8.475,8.475",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1629",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1631",
    transform: "translate(440.3437,306.6245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -8.476,8.475",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1633",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1635",
    transform: "translate(399.2168,295.2314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -82.227 c -3.618,0 -6.578,-2.96 -6.578,-6.579 v -27.744 c 0,-3.618 2.96,-6.578 6.578,-6.578 H 0 c 3.618,0 6.578,2.96 6.578,6.578 V -6.579 C 6.578,-2.96 3.618,0 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1637",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1639",
    transform: "translate(329.2949,227.8051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 2.514,-13.631 14.451,-23.959 28.809,-23.959 14.357,0 26.295,10.328 28.807,23.959 z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1641",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1643",
    transform: "translate(358.1035,492.5151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 11.985",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1645",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1647",
    transform: "translate(339.747,467.2768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -35.72,-8.401 -62.412,-40.719 -62.199,-78.871 0.153,-27.583 14.172,-51.88 35.437,-66.283 6.133,-4.153 9.836,-11.05 9.836,-18.456 v -8.435 h 70.564 v 8.432 c 0,7.324 3.565,14.238 9.641,18.328 17.116,11.519 29.559,29.436 33.922,50.322",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1649",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1651",
    transform: "translate(436.5117,407.3139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -7.096,30.269 -31.245,53.965 -61.765,60.381",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path1653",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdea);
export default __webpack_public_path__ + "static/media/icon-idea.e3fd8c7c98b7826d3284443888c1a4b2.svg";
export { ForwardRef as ReactComponent };